"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
var _services = require("../../services");
var _useComparisonNavigation = _interopRequireDefault(require("../../hooks/comparison/useComparisonNavigation"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useComparison = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeadingWrapper = _styledComponents.default.div`
  text-align: center;
`;
const ComparisonHeader = _ref => {
  let {
    showHeaderTitle,
    showBackArrow = true
  } = _ref;
  const {
    onBack
  } = (0, _useComparisonNavigation.default)();
  const {
    showDevices,
    showPlans
  } = (0, _useComparison.default)();
  let comparisonButtonText;
  if (showDevices) {
    comparisonButtonText = _services.Services.locale.localeString('Comparison.CompareDevices');
  } else if (showPlans) {
    comparisonButtonText = _services.Services.locale.localeString('Comparison.ComparePlans');
  } else {
    comparisonButtonText = _services.Services.locale.localeString('Comparison.CompareBroadbands');
  }
  const actionComponentContent = showBackArrow ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    dataAttributes: {
      'data-id': 'modal-arrow-back'
    },
    srText: _services.Services.locale.localeString('Recommendation.IconBack'),
    name: "arrow-left",
    appearance: "primary",
    onClick: onBack
  }) : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    actionComponent: actionComponentContent,
    isCloseButtonHidden: false,
    id: "comparison-header-top"
  }))), showHeaderTitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 5,
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(HeadingWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    id: "comparison-heading",
    size: 2,
    weight: 3,
    text: comparisonButtonText
  }))))));
};
var _default = ComparisonHeader;
exports.default = _default;